export * from './ContentfulIngredientsTabs';
export * from './IngredientsTabs';
